export default __webpack_public_path__ + "assets/json/girl.7f216d.json";